import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { RepaymentRequest } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";

import { Badge } from "@/components/ui/badge/badge";
import { datesMatch } from "@/utils";
// import { DataTableRowActions } from "./data-table-row-actions";

export const columns: ColumnDef<RepaymentRequest, any>[] = [
  {
    accessorKey: "createdAt",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => (
      <div className="w-[220px] flex flex-col">
        <span>{row.index + 1}</span>
        <span className="text-xs">
          (Payment on - {format(row.getValue("createdAt"), "PPP")} )
        </span>
      </div>
    ),
    enableSorting: false,
    enableHiding: false,

    filterFn: (row, id, value) => {
      return datesMatch(row.getValue(id), value);
    },
  },
  {
    accessorKey: "amount",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Amount" />
    ),
    cell: ({ row }) => (
      <div className="flex flex-col gap-1">
        <span>{row.getValue("amount")}</span>
      </div>
    ),
    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id));
    },
    enableSorting: false,
  },

  {
    accessorKey: "employeeName",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Employee" />
    ),
    cell: ({ row }) => <div>{row.getValue("employeeName")}</div>,
    enableColumnFilter: false,
    enableSorting: false,
  },

  {
    accessorKey: "status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => (
      <div>
        <Badge variant="outline">{row.getValue("status")}</Badge>
      </div>
    ),
    enableColumnFilter: false,
    enableSorting: false,
  },

  // {
  //   id: "actions",
  //   cell: ({ row }) => <DataTableRowActions row={row} />,
  // },
];
